import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { formatFromSearchType } from '../../../util/formatUtil';
import { SearchAsk, SearchInputText, SearchImageLeft, SearchImageRight } from '../common/PageLayout.styles';

class ReduxSearchInput extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isInputFocused: false,
    };
  }

  getDisplayValue() {
    const { searchValue, valueToMask, searchType } = this.props;

    const shouldMaskValue = searchValue === valueToMask;

    return shouldMaskValue ? formatFromSearchType(searchType, searchValue) : searchValue || '';
  }

  setSearchValue(value) {
    this.props.onChangeFunction(value);
  }

  runSearchOnEnter(event) {
    if (event.key === 'Enter') {
      this.props.onClickFunction?.();
    }
  }

  render() {
    const { onClickFunction, placeholder = null, messageImg = true, searchType } = this.props;

    return (
      <SearchAsk focused={this.state.isInputFocused}>
        <SearchImageLeft hide={!messageImg}>
          {messageImg ? <img src="/images/message-box.svg" alt="" /> : null}{' '}
        </SearchImageLeft>
        <SearchInputText
          value={this.getDisplayValue() || ''}
          key={searchType}
          onFocus={() => this.setState({ isInputFocused: true })}
          onBlur={() => this.setState({ isInputFocused: false })}
          onChange={(event) => this.setSearchValue(event.target.value)}
          placeholder={placeholder || 'Ask a question'}
          onKeyUp={(event) => this.runSearchOnEnter(event)}
        />
        <SearchImageRight onClick={() => onClickFunction(this.props.searchValue)}>
          <img style={{ width: '15px' }} src="/images/magnifying-glass.svg" alt="" />
        </SearchImageRight>
      </SearchAsk>
    );
  }
}

ReduxSearchInput.propTypes = {
  onClickFunction: PropTypes.func,
  onChangeFunction: PropTypes.func.isRequired,
  valueToMask: PropTypes.string,
  searchType: PropTypes.string,
  placeholder: PropTypes.string,
};

export default ReduxSearchInput;
